import TableText from "@/components/table/TableText";
import { Button, message, Row, Table, Spin } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "../../Auth";
import imgSave from "../../saveImg";
import { SPR } from "./compute";
import FileSaver from "file-saver";

class index extends Component {
    state = {
        loading: false,
        print: false,
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_2_2', 1.5, '4.212', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }
    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} 4.2.1.2 Golden Week or Public Holiday Booking Path report 法定小长假售卖情况报表`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }
    render() {
        const { print, loading } = this.state;
        const { data, date, } = this.props;
        const columns = [{
            title: 'Date',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "name", };
                return <TableText data={props} />
            }
        }, {
            title: 'Week',
            dataIndex: 'week',
            key: 'week',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const spr = ['除夕', '初一', '初二', '初三', '初四', '初五', '初六', '初七'];
                const week = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日'][moment(`${date}-${index + 1}`).format('E')];
                const props = { text: week, index, type: 'text', name: "name", };
                if (SPR[moment(date).format('Y')].m == moment(date).format('M')) {
                    props.text = spr[index];
                }
                return <TableText data={props} />
            }
        }, {
            title: 'Available room',
            dataIndex: 'ava',
            key: 'ava',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'number', name: "ava", };
                return <TableText data={props} />
            }
        }, {
            title: 'Sold Room',
            dataIndex: 'sold',
            key: 'sold',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'number', name: "sold", };
                return <TableText data={props} />
            }
        }, {
            title: 'Occupancy %',
            dataIndex: 'occ',
            key: 'occ',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'percent', name: "occ", };
                return <TableText data={props} />
            }
        }, {
            title: 'ADR',
            dataIndex: 'adr',
            key: 'adr',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'number', name: "adr", };
                return <TableText data={props} />
            }
        }, {
            title: 'RevPAR',
            dataIndex: 'revpar',
            key: 'revpar',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'number', name: "revpar", };
                return <TableText data={props} />
            }
        }, {
            title: 'Room Revenue',
            dataIndex: 'rev',
            key: 'rev',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const props = { text, index, type: 'number', name: "rev", };
                return <TableText data={props} />
            }
        }, {
            title: 'Room Revenue %',
            dataIndex: 'revper',
            key: 'revper',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'percent', name: "revper", };
                if (index == 33) props.type = '';
                return <TableText data={props} />
            }
        }, {
            title: 'Hotel Total Revenue',
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = { text, index, type: 'number', name: "total", };
                if (index == 33) props.type = '';
                return <TableText data={props} />
            }
        }];
        let dataSource = [];
        if (moment(date).format('M') == 5 || moment(date).format('M') == 10) {
            // 五一、十一
            dataSource = data.slice(0, 7);
        } else if (SPR[moment(date).format('Y')].m == moment(date).format('M')) {
            // 春节
            const index = SPR[moment(date).format('Y')].d - 1;
            dataSource = data.slice(index, index + 7);
        }
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 table7_6" id="table4_2_2" style={{ height: 'auto' }}>
                    <Row className="title">
                        <Row>4.2.1.2 Golden Week or Public Holiday Booking Path report 法定小长假售卖情况报表</Row>
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            size="middle"
                            bordered
                            id="table4_2_2_export"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                        <Button
                            type="primary"
                            style={{ float: 'right', marginTop: 20 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={print}
                        >导出Excel</Button>
                    </Row>
                    <Row className="title">
                        <div className="chart-4-2">
                            <div id="chartHolidayOcc"></div>
                            <div id="chartHolidayAdr"></div>
                            <div id="chartHolidayRevpar"></div>
                            <div id="chartHolidayRoomRev"></div>
                        </div>
                        <Auth loading={loading} auth="edit_4_2">
                            <Row className="table-footer-btn" style={{ display: print ? 'none' : "" }}>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 10 }}
                                    onClick={this.downloadSG}
                                    loading={print}
                                >加入pdf</Button>
                            </Row>
                        </Auth>

                    </Row>
                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/4-2-2.js